__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-digital-identity-unsubscribe'].baseUrl;
import ModuleContainer from './AxpDigitalIdentityUnsubscribe';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "7.x"
  });
}